var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104.78 110.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "not_available",
    "data-name": "not available",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    className: "cls-2",
    x: 8.67,
    width: 86.55,
    height: 103.17,
    rx: 18.72
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_101-2",
    "data-name": "Rectangle 101-2",
    className: "cls-2",
    d: "M13.62,101.54H5.51A5.51,5.51,0,0,1,0,96V35.8A2.76,2.76,0,0,1,2.75,33H16.38a2.76,2.76,0,0,1,2.75,2.76V96A5.51,5.51,0,0,1,13.62,101.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_102-2",
    "data-name": "Rectangle 102-2",
    className: "cls-2",
    d: "M99.27,101.54H91.15A5.51,5.51,0,0,1,85.65,96V35.8A2.76,2.76,0,0,1,88.4,33H102a2.76,2.76,0,0,1,2.75,2.76V96A5.51,5.51,0,0,1,99.27,101.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103-2",
    "data-name": "Rectangle 103-2",
    className: "cls-2",
    x: 0.01,
    y: 79.66,
    width: 104.77,
    height: 30.81,
    rx: 9.76
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.334c84ec951870553925bb3b567a7db4.svg";
export { ForwardRef as ReactComponent };